import { useTheme } from '@mui/material';
import React from 'react';

const RouteStepArrow = () => {
  const theme = useTheme();
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.728523 0.271C0.90919 0.0903332 1.10352 0 1.31152 0C1.52019 0 1.71486 0.0903332 1.89552 0.271L4.99952 3.375L8.10352 0.271C8.28419 0.0903332 8.48219 0 8.69752 0C8.91286 0 9.11086 0.0903332 9.29152 0.271C9.47152 0.451667 9.56152 0.649666 9.56152 0.865C9.56152 1.08033 9.47152 1.27133 9.29152 1.438L5.58252 5.146C5.48586 5.24333 5.38886 5.31267 5.29152 5.354C5.19419 5.396 5.09686 5.417 4.99952 5.417C4.90219 5.417 4.80486 5.396 4.70752 5.354C4.61019 5.31267 4.51319 5.24333 4.41652 5.146L0.707523 1.438C0.540857 1.27133 0.457523 1.08033 0.457523 0.865C0.457523 0.649666 0.547857 0.451667 0.728523 0.271Z"
        fill={theme.palette.widget['icon-02']}
      />
    </svg>
  );
};

export default RouteStepArrow;
